import * as React from "react";

import { Paper, Chip, LinearProgress } from '@material-ui/core';

import { Query } from 'react-apollo';
import * as ReactTooltip from 'react-tooltip';

import './PublisherFilterChip.scss';
import { QUERY_FILTER_UPDATE_PUBLISHER, QueryFilter } from "src/component/shared";
import { PUBLISHER_BOOKSTORE_FILTER } from '../filter/publisher-bookstore-filter/PublisherBookstoreFilter';
import { PUBLISHER_BOOK_FILTER } from '../filter/publisher-book-filter/PublisherBookFilter';
import { PUBLISHER_ECONOMIC_GROUP_FILTER } from '../filter/publisher-economic-group-filter/PublisherEconomicGroupFilter';
import { PUBLISHER_PUBLISHER_FILTER } from '../filter/publisher-publisher-filter/PublisherPublisherFilter';
import { PUBLISHER_STAMP_FILTER } from '../filter/publisher-stamp-filter/PublisherStampFilter';
import { PUBLISHER_UF_FILTER } from '../filter/publisher-uf-filter/PublisherUfFilter';
import { PUBLISHER_BISAC_FILTER } from "../filter/publisher-bisac-filter/PublisherBisacFilter";
import { PUBLISHER_AUTHOR_FILTER } from "../filter/publisher-author-filter/PublisherAuthorFilter";
import { PUBLISHER_BISAC_CODE_FILTER } from '../filter/publisher-bisac-code-filter/PublisherBisacCodeFilter';

export interface IChipData {
    key: number;
    label: string;
    filter: any;
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherFilterChipProps {
    // data: IChipData[];
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherFilterChipState {
    data: IChipData[];
}

export class PublisherFilterChip extends React.Component<IPublisherFilterChipProps, IPublisherFilterChipState> {

    constructor(props: IPublisherFilterChipProps) {
        super(props);

        // Set initial state
        this.state = { data: [] };
    }

    public render() {
        return (<Query query={QUERY_FILTER_UPDATE_PUBLISHER}>
                    {({ loading, error, data, client }) => {
                        const arrayFilter = [];
                        if (data.FILTER_publisherBookFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherBookFilter',
                                field: 'books',
                                filterChecked: data.FILTER_publisherBookFilterChecked,
                                key: 1,
                                label:'Livros',
                                query: PUBLISHER_BOOK_FILTER,
                                queryField: 'description',
                            });
                        }
                        if (data.FILTER_publisherBookstoreFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherBookstoreFilter',
                                field: 'bookstores',
                                filterChecked: data.FILTER_publisherBookstoreFilterChecked,
                                key: 2,
                                label:'Livrarias',
                                query: PUBLISHER_BOOKSTORE_FILTER,
                                queryField: 'name',
                            });
                        }
                        if (data.FILTER_publisherEconomicGroupFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherEconomicGroupFilter',
                                field: 'groups',
                                filterChecked: data.FILTER_publisherEconomicGroupFilterChecked,
                                key: 3,
                                label:'Grupos',
                                query: PUBLISHER_ECONOMIC_GROUP_FILTER,
                                queryField: 'group',
                            });
                        }
                        if (data.FILTER_publisherPublisherFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherPublisherFilter',
                                field: 'publishers',
                                filterChecked: data.FILTER_publisherPublisherFilterChecked,
                                key: 4,
                                label:'Editoras',
                                query: PUBLISHER_PUBLISHER_FILTER,
                                queryField: 'fabricator',
                            });
                        }
                        if (data.FILTER_publisherStampFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherStampFilter',
                                field: 'stambs',
                                filterChecked: data.FILTER_publisherStampFilterChecked,
                                key: 5,
                                label:'Selos',
                                query: PUBLISHER_STAMP_FILTER,
                                queryField: 'stamp',
                            });
                        }
                        if (data.FILTER_publisherUfFilterChecked.length > 0){
                            arrayFilter.push({
                                dataName: 'publisherUfFilter',
                                field: 'ufs',
                                filterChecked: data.FILTER_publisherUfFilterChecked,
                                key: 6,
                                label:'Estado',
                                query: PUBLISHER_UF_FILTER,
                                queryField: 'state',
                            });
                        }
                        if(data.FILTER_publisherBisacFilterChecked.length > 0) {
                            arrayFilter.push({
                                dataName: 'publisherBisacFilter',
                                field: 'bisac',
                                filterChecked: data.FILTER_publisherBisacFilterChecked,
                                key: 7,
                                label:'Categoria',
                                query: PUBLISHER_BISAC_FILTER,
                                queryField: 'description',
                            });
                        }
                        if(data.FILTER_publisherAuthorFilterChecked.length > 0) {
                            arrayFilter.push({
                                dataName: 'publisherAuthorFilter',
                                field: 'author',
                                filterChecked: data.FILTER_publisherAuthorFilterChecked,
                                key: 8,
                                label:'Autor',
                                query: PUBLISHER_AUTHOR_FILTER,
                                queryField: 'name',
                            });
                        }
                        if(data.FILTER_publisherBisacCodeFilterChecked.length > 0) {
                            arrayFilter.push({
                                dataName: 'publisherBisacCodeFilter',
                                field: 'bisac_code',
                                filterChecked: data.FILTER_publisherBisacCodeFilterChecked,
                                key: 9,
                                label:'Bisac',
                                query: PUBLISHER_BISAC_CODE_FILTER,
                                queryField: 'bisac',
                            });
                        }

                        return (arrayFilter.length > 0 ?
                        <div id="chips" className="wrapper"><Paper>
                            <div className="filter-chip-bar">
                                {loading && <LinearProgress />}
                                {error && `Error! ${error.message}`}
                                {arrayFilter.map(
                                    (item: any) => {
                                        return (
                                        <div key={item.field}>
                                            <Query query={item.query}
                                                variables={QueryFilter.getFilterPublisherByChip(client, {
                                                    "customFilter": {
                                                            "isChart": true,
                                                    }
                                                }, [item.field])}>
                                                    {(dataFilter: any) => {
                                                        if (dataFilter.loading) {
                                                            return <Chip
                                                                key={item.key}
                                                                label={item.label}
                                                                onDelete={this.handleDelete({ key: item.key, label: item.label, filter: item }, client)}
                                                                className="filter-chip"
                                                            />;
                                                        }

                                                        return (
                                                            <div>
                                                                <a data-tip={true} data-for={item.field}>
                                                                    <Chip
                                                                        key={item.key}
                                                                        label={item.label}
                                                                        onDelete={this.handleDelete({ key: item.key, label: item.label, filter: item }, client)}
                                                                        className="filter-chip"
                                                                    />
                                                                </a>
                                                                <ReactTooltip id={item.field} place="bottom" aria-haspopup="true" effect="solid" type="light">
                                                                    {
                                                                        dataFilter.data && (dataFilter.data[item.dataName].filter((itemFilter: any) => {
                                                                            if (item.filterChecked.indexOf(itemFilter.id.toString()) > -1) {
                                                                                return true;
                                                                            }

                                                                            return false;
                                                                        }).map((itemFilter: any, key: any) => {
                                                                            return <div key={key} className="tooltip-chip">
                                                                                {itemFilter[item.queryField]}
                                                                            </div>
                                                                        }))
                                                                    }
                                                                </ReactTooltip>
                                                            </div>
                                                        );
                                                    }}
                                            </Query>
                                        </div>
                                    )}
                                )}
                            </div>
                            </Paper></div> : '')}}
                </Query>)
    }

    private handleDelete = (data: IChipData, client: any) => {
        return () => {

            if (data.key === 1){
                client.writeData({ data: {
                    FILTER_publisherBookFilterChecked: [],
                } });
            }
            if (data.key === 2){
                client.writeData({ data: {
                    FILTER_publisherBookstoreFilterChecked: [],
                } });
            }
            if (data.key === 3){
                client.writeData({ data: {
                    FILTER_publisherEconomicGroupFilterChecked: [],
                } });
            }
            if (data.key === 4){
                client.writeData({ data: {
                    FILTER_publisherPublisherFilterChecked: [],
                } });
            }
            if (data.key === 5){
                client.writeData({ data: {
                    FILTER_publisherStampFilterChecked: [],
                } });
            }
            if (data.key === 6){
                client.writeData({ data: {
                    FILTER_publisherUfFilterChecked: [],
                } });
            }
            if (data.key === 7){
                client.writeData({ data: {
                    FILTER_publisherBisacFilterChecked: [],
                } });
            }
            if (data.key === 8){
                client.writeData({ data: {
                    FILTER_publisherAuthorFilterChecked: [],
                } });
            }
            if (data.key === 9){
                client.writeData({ data: {
                    FILTER_publisherBisacCodeFilterChecked: [],
                } });
            }

            QueryFilter.updateMutationPublisher();

        }
    };
}



// WEBPACK FOOTER //
// ./src/component/publisher/shared/chips/PublisherFilterChip.tsx